import { combineReducers } from 'redux';

import user from './user';
import layout from './layout';
import syncs from './syncs';
import cidades from './cidades';
import culturas from './culturas';
import estados from './estados';
import pems from './pems';
import queue from './queue';
import perguntas from './perguntas';
import respostas from './respostas';
import produtos from './produtos';
import etapas from './etapas';
import impactos from './impactos';
import grupos from './grupos';
import permissoes from './permissoes';
import users from './users';
import dadosIniciais from './dadosIniciais';

export default combineReducers({
  users,
  user,
  layout,
  syncs,
  cidades,
  culturas,
  estados,
  pems,
  queue,
  perguntas,
  respostas,
  produtos,
  etapas,
  dadosIniciais,
  impactos,
  grupos,
  permissoes,
});

export const Reducers = {
  users,
  user,
  layout,
  syncs,
  cidades,
  culturas,
  estados,
  pems,
  queue,
  perguntas,
  respostas,
  produtos,
  etapas,
  dadosIniciais,
  impactos,
  grupos,
  permissoes,
};
